import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/inverted-shipedBL.svg'


const _withScopeId = n => (_pushScopeId("data-v-39772829"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footerWrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "group1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logotyp",
  class: "logotyp"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "tag-text"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "group2" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"contact\" data-v-39772829><p class=\"contact-text\" data-v-39772829> Contact: <br data-v-39772829><a class=\"left\" href=\"mailto:oops@getshipd.co\" data-v-39772829>oops@getshipd.co</a></p><p class=\"contact-text\" data-v-39772829> Enterprise Sales: <br data-v-39772829><a class=\"left\" href=\"mailto:sales@getshipd.co\" data-v-39772829>sales@getshipd.co</a></p></div>", 1)
const _hoisted_10 = { class: "pages" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cookies", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Terms of service", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Privacy policy", -1))
const _hoisted_14 = {
  key: 0,
  class: "tag-text"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          ($setup.windowSize >= 995)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(" Copyright © 2024 Leija Software AB All rights reserved. "),
                _hoisted_7,
                _createTextVNode(" Organization number: 559317-2801 ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/cookies" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/tos" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/privacy" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            ($setup.windowSize < 995)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                  _createTextVNode(" Copyright © 2022 Leija Software AB All rights reserved. "),
                  _hoisted_15,
                  _createTextVNode(" Organization number: 559317-2801 ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}